module.exports = __webpack_public_path__ + "img/jingdian-bg.e58b0bae.png";